///include /assets/js/app/p/spayment-item.js
///include /assets/js/app/s/basket.js
///include /assets/js/app/p/brand.js
///include /assets/js/app/p/description-template-compiler.js

"use strict"

const _twigTemplateCache = {}

class SPccategoryPage {
    init() {
        this.view = new Vue({
            el: ".vue-wrapper",
            name: "order-hosting",
            data() {
                return {
                    /** @type {SBasket} */
                    ///@ts-ignore
                    basket: AnyBasket.inst,
                    /** @type {?*} */
                    brand: null,
                    catalogue: UserCatalogue.inst,
                    customCategory: null,
                    format: Site.Format,
                    settings: SharedSettings.inst,
                    selectedPeriod: null,
                }
            },
            computed: {
                contact() {
                    return this.settings.contact;
                },
                haveHostinglimits() {
                    if( this.hostingProducts ){
                        return this.hostingProducts.every( h => h.limits );
                    } else {
                        return false;
                    }
                },
                notHiddenProducts() {
                    return this.products.filter(p => !p.hidden).sort((a, b) => a.shopDisplayOrder - b.shopDisplayOrder);
                },
                loading() {
                    return !(
                        this.brand &&
                        this.catalogue.products &&
                        this.catalogue.isOpen !== null &&
                        this.haveHostinglimits &&
                        this.customCategory
                    )
                },
                customCategoryProductCodes() {
                    if (this.customCategory && this.catalogue && this.catalogue.products) {
                        return this.customCategory.products.filter(p => {
                            return !!this.catalogue.products.find(pr => pr.code == p)
                        })
                    }
                },
                /** @type {SBHostingProduct[]} */
                products() {
                    const products = this.customCategoryProductCodes?.map(c => {
                        return this.catalogue.products.find(p => p.code == c && p.forSale)
                    })
                    return products ? products : []
                },
                wordpressProducts() {
                    return this.products.filter(
                        p => p.platform == "wordpress"
                    )
                },
            },
            watch: {
                loading(v) {
                    if(!v) {
                        Vue.nextTick( () => {
                            $( ".page-loaded-content" ).fadeTo(200,1, function() {});
                        });
                    }
                }
            },
            methods: {
                periodOptions(pricing) {
                    var seen = [];
                    var months = [];
                    pricing.forEach( (p) => {
                        if( !seen.includes(p.periodMonths) ){
                            seen.push(p.periodMonths);
                            months.push({
                                text: this.intervalMonthsLabel(p.periodMonths),
                                id: p.periodMonths
                            });
                        }
                    } );
                    return months;
                },
                async addCustomProductToBasket(customProduct) {
                    // Get the price.
                    const prices = customProduct.pricing;
                    const pic = PaymentItemCollection.inst
                    // Get affiliate from cookie
                    const affiliate = getCookie("affiliate")
                    await this.basket.addWithInfo(
                        {
                            paymentItemCountries:
                                await pic.preloadSingle("countriesFlat"),
                            affiliateCode: affiliate
                        },
                        await customProduct.basketItem(
                            prices[0],
                            null,
                            1,
                            null
                        ),
                    )
                    setTimeout(() => {
                        if(!!this.settings.authenticatedUser) {
                            location.href = "/checkout"
                        } else {
                            location.href = "/basket-summary-login?r=/checkout"
                        }
                    }, 300) // Work around HTTP2 offloading x firefox
                },

                productDescription(type) {
                    const group = `group-${type}`
                    return(
                        this.catalogue.productDescriptionFromCode(group, translation.getActiveLanguage()) ||
                        Catalogue.defaultProductDescription(group).content
                    )
                },
                bestSelectPeriod(pricing){
                    var period = +(this.selectedPeriod || (this.catalogue.prefs && this.catalogue.prefs.defaultHostingPeriodMonths) || 1);
                    if( period && pricing.some( p=> p.periodMonths == period ) ){
                        var p = pricing.find( p=> p.periodMonths == period );
                        return p.periodMonths;
                    } else {
                        return pricing[0].periodMonths;
                    }
                },

                hostingLink(hosting_product) {
                    const packageAllowanceCode = hosting_product.code.split(":")[1]
                    return `/domain-required?p=${packageAllowanceCode}&t=${this.bestSelectPeriod(hosting_product.pricing)}`
                },

                compiledDescription(hp, lang = "en-GB"){
                    if( this.catalogue.prefs && this.catalogue.prefs.preferGB ){
                        Site.Format.preferGB = true;
                    }
                    var template = this.catalogue.productDescriptionFromCode(hp.code, translation.getActiveLanguage()) || "{{limits.compiledTable}}";

                    var limitsInUse = hp.limits ? Object.assign(hp.limits,{display:{}}) : {display:{}};
                    if( hp.limits ){
                        /**
                         * Decoupled for translation needs
                         * Converted to if statements for better readability...
                         */

                        /** Mailboxes template */
                        if(twigExtender.limit(hp.limits.mailboxes) === Infinity) {
                            limitsInUse.display.mailboxes = translation.sprintf(
                                translation.get(`group_template_unlimited_x_mailboxes`),
                                [Site.Format.GBorMB(hp.limits.maxMailboxSize * 2 ** 20)])
                        } else {
                            limitsInUse.display.mailboxes = translation.sprintf(
                                translation.get(`group_template_mailboxes_x_megabytes_mailboxes`),
                                [
                                    Site.Format.number(twigExtender.limit(hp.limits.mailboxes)),
                                    Site.Format.GBorMB(hp.limits.maxMailboxSize * 2 ** 20)
                                ]
                            )
                        }
                        /** Mailboxes template */

                        /** Domain template */
                        if(hp.limits.domains) {
                            if((twigExtender.limit(hp.limits.domains)+1) === Infinity) {
                                limitsInUse.display.domains = translation.get(`group_template_unlimited_domains`)
                            } else {
                                limitsInUse.display.domains = translation.sprintf(
                                    translation.get(`group_template_number_more_than_1_domains`),
                                    [Site.Format.number(twigExtender.limit(hp.limits.domains)+1)]
                                )
                            }
                        } else {
                            limitsInUse.display.domains = translation.get(`group_domain_description_1_domain`)
                        }
                        /** Domain template */

                        /** Web Space template */
                        if(twigExtender.limit(hp.limits.webspace) === Infinity) {
                            limitsInUse.display.webspace = translation.get(`group_template_unlimited_ssd`)
                        } else {
                            limitsInUse.display.webspace = translation.sprintf(
                                translation.get(`group_template_megabytes_ssd_web_space`),
                                [Site.Format.GBorMB(twigExtender.limit(hp.limits.webspace) * 2 ** 20)]
                            )
                        }
                        /** Web Space template */

                        /** Bandwith template */
                        if(twigExtender.limit(hp.limits.bandwidth) === Infinity) {
                            limitsInUse.display.bandwidth = translation.get(`group_template_unlimited_bandwidth`)
                        } else {
                            limitsInUse.display.bandwidth = translation.sprintf(
                                translation.get(`group_template_megabytes_month_bandwidth`),
                                [Site.Format.GBorMB(hp.limits.bandwidth * 2 ** 20)]
                            )
                        }
                        /** Bandwith template */

                        /** MySQL template */
                        limitsInUse.display.mysqlDatabases = translation.sprintf(
                            translation.get(`group_template_number_x_mysql_database`),
                            [Site.Format.number(twigExtender.limit(hp.limits.mysqlDatabases))]
                        )
                        /** MySQL template */

                        if (!_twigTemplateCache[lang]) {
                            _twigTemplateCache[lang] = Twig.twig({data: DefaultTemplateCompiler.getTemplateByType('package', lang), rethrow: true });
                        }
                        limitsInUse.compiledTable = _twigTemplateCache[lang].render( Object.assign(twigExtender, {limits:limitsInUse,hp:hp}) );
                    }
                    var result = DefaultTemplateCompiler.compile(template,{limits:limitsInUse,hp:hp});
                    return result;
                },

                /**
                 * @param {number} m
                 * @returns {string}
                 */
                intervalMonthsLabel(m) {
                    if( m == 1 ){
                        return translation.get('global_shop_per_month')
                    }
                    return Catalogue.intervalMonthsLabel(m)
                },
                /**
                 * @param {number | "INF" | null} v
                 * @returns {number | null}
                 */
                limit(v) {
                    if(v == "INF") {
                        return Infinity
                    } else {
                        return v
                    }
                },

                monthLabel(pricing) {
                    var period = +(
                        this.selectedPeriod ||
                        (this.catalogue.prefs?.advertiseMonthlyEquivalent ? 1 : null) ||
                        (this.catalogue.prefs && this.catalogue.prefs.defaultHostingPeriodMonths) || 1
                    );
                    if( period && pricing.some( p=> p.periodMonths == period ) ){
                        var p = pricing.find( p=> p.periodMonths == period );
                        return this.intervalMonthsLabel(this.catalogue?.prefs?.advertiseMonthlyEquivalent ? 1 : p.periodMonths);
                    } else {
                        return this.intervalMonthsLabel(this.catalogue?.prefs?.advertiseMonthlyEquivalent && pricing[0].periodMonths ? 1 : pricing[0].periodMonths);
                    }
                },
                minorPrice(pricing) {
                    if (this.catalogue.prefs && this.catalogue.prefs.advertiseMonthlyEquivalent){
                        let price = pricing.map((p) => {
                          return p.price / (p.periodMonths == 0 ? 1 : p.periodMonths);
                        }).sort( (a, b) => {
                          return a - b;
                        })[0];
                        return this.format.priceTail(price, this.catalogue.currency);
                    } else {
                        var period = +(this.selectedPeriod || (this.catalogue.prefs && this.catalogue.prefs.defaultHostingPeriodMonths) || 1);
                        if( period && pricing.some( p=> p.periodMonths == period ) ){
                            var p = pricing.find( p=> p.periodMonths == period );
                            return this.format.priceTail(p.price, this.catalogue.currency)
                        } else {
                            return this.format.priceTail(pricing[0].price, this.catalogue.currency)
                        }
                    }
                },
                majorPrice(pricing) {
                    if (this.catalogue.prefs && this.catalogue.prefs.advertiseMonthlyEquivalent){
                        let price = pricing.map((p) => {
                          return p.price / (p.periodMonths == 0 ? 1 : p.periodMonths);
                        }).sort( (a, b) => {
                          return a - b;
                        })[0];
                        return this.format.priceMajor(price, this.catalogue.currency);
                    } else {
                        var period = +(this.selectedPeriod || (this.catalogue.prefs && this.catalogue.prefs.defaultHostingPeriodMonths) || 1);
                        if( period && pricing.some( p=> p.periodMonths == period ) ){
                            var p = pricing.find( p=> p.periodMonths == period );
                            return this.format.priceMajor(p.price, this.catalogue.currency)
                        } else {
                            return this.format.priceMajor(pricing[0].price, this.catalogue.currency)
                        }
                    }
                }
            },
            components: {
                shopNav: ShopNav,
                "vue-select": VueSelect
            },
            mounted() {
                const qs = new URLSearchParams(window.location.search)
                const params = Object.fromEntries(qs.entries());
                $.ajax(`/a/catalogue/productCustomCategory`)
                .then(r => {
                    const cat = r.find(c => c.id == params.cat)
                    if (!cat) return false
                    this.customCategory = cat
                })

                this.catalogue.assertExists()
            },
        })
    }
}
